<template>
   <div class="v-sidebar-content">
    <filters-block :title="localizeList.directsUpper" :open="1" small-header small-body>
        <div class="filter-list">
            <div v-for="(item, key) in directsItems"
                    :key="key"
                    class="filter-item mb-6">
                <radio-btn :value="item.isChecked"
                            @change="changeDirect(key)">
                    {{localizeList[item.name]}}
                </radio-btn>
            </div>
        </div>
    </filters-block>

    <filters-block :title="localizeList.baggageYesNoUpper" :open="1" small-header small-body>
        <div class="filter-list">
            <div v-for="(item, key) in luggageItems"
                    :key="key"
                    class="filter-item mb-6">
                <radio-btn :value="item.isChecked"
                            @change="changeLuggage(key)">
                    {{localizeList[item.name]}}
                </radio-btn>
            </div>
        </div>
    </filters-block>

    <filters-block v-if="showFilterWithSlider" :title="localizeList.durationTransfers" :open="1" small-header small-body>
        <div class="filter-list">
            <div class="filter-item mb-6">
                <div class="departure-there">
                    <div class="mb-8">
                        <p class="standard-text">
                            <span class="blue-bold-text">{{connectionLimit[0]|time}} – {{connectionLimit[1]|time}}</span>
                        </p>
                    </div>

                    <div class="v-width-slider">
                        <base-slider v-model="connectionLimit"
                                    @change="changeConnectionLimit($event)"
                                    :disabled="!this.connectionLimitSize[1]"
                                    :size="connectionLimitSize"/>
                    </div>
                </div>
            </div>
        </div>
    </filters-block>
    
    <filters-block :title="localizeList.flightClass" small-header small-body>
        <div class="filter-list">
            <div v-for="(item, key) in classItems"
                    :key="key"
                    class="filter-item mb-6">
                <radio-btn :value="item.isChecked"
                            @change="changeClass(key)">
                    {{localizeList[item.name]}}
                </radio-btn>
            </div>
        </div>
    </filters-block>

    <filters-block :title="localizeList.travelTimeTitle" small-header small-body>
        <span class="standard-text v-sidebar-subtitle">{{cityFrom}} – {{cityTo}}</span>

        <div class="filter-list">
            <div class="filter-item mb-10">
                <div class="departure-there">
                    <div class="mb-8">
                        <p class="standard-text">
                            {{localizeList.forward}}:
                            <span class="blue-bold-text">{{toTimeLimit[0]|time}} – {{toTimeLimit[1]|time}}</span>
                        </p>
                    </div>

                    <div class="v-width-slider">
                        <base-slider v-model="toTimeLimit" @change="changeToTimeLimit($event)"
                                     :size="toTimeLimitSize"/>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="backTimeLimit[0] && backTimeLimit[1]" class="filter-list">
            <div class="filter-item mb-10">
                <div class="departure-there">
                    <div class="mb-8">
                        <p class="standard-text">
                            {{localizeList.backward}}:
                            <span class="blue-bold-text">{{backTimeLimit[0]|time}} – {{backTimeLimit[1]|time}}</span>
                        </p>
                    </div>

                    <div class="v-width-slider">
                        <base-slider v-model="backTimeLimit" @change="changeBackTimeLimit($event)"
                                     :size="backTimeLimitSize"/>
                    </div>
                </div>
            </div>
        </div>
    </filters-block>

    <filters-block :title="localizeList.forward" small-header small-body>
        <span class="standard-text v-sidebar-subtitle">{{cityFrom}} – {{cityTo}}</span>

        <div class="filter-list">
            <div class="filter-item mb-10">
                <div class="departure-there">
                    <div class="mb-8">
                        <p class="standard-text">
                            {{localizeList.flightDepartureUpper}}:
                            <span class="blue-bold-text">{{toDepartureTime[0]|time}} – {{toDepartureTime[1]|time}}</span>
                        </p>
                    </div>

                    <div class="v-width-slider">
                        <base-slider v-model="toDepartureTime" @change="changeToDepartureTime($event)"
                                    :size="toDepartureTimeLimit"/>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="filter-list">
            <div class="filter-item mb-6">
                <div class="departure-there">
                    <div>
                        <p class="standard-text v-sidebar-subtitle">
                            {{localizeList.flightArrivalUpper}}:
                            <span class="blue-bold-text">{{toArrivalTime[0]|time}} – {{toArrivalTime[1]|time}}</span>
                        </p>
                    </div>

                    <div class="v-width-slider">
                        <base-slider v-model="toArrivalTime" @change="changeToArrivalTime($event)"
                                     :size="[0,1439]"/>
                    </div>
                </div>
            </div>
        </div>
    </filters-block>

    <filters-block v-if="backTimeLimit[0] && backTimeLimit[1]" :title="localizeList.backward" small-header small-body>
        <span class="standard-text v-sidebar-subtitle">{{cityTo}} – {{cityFrom}}</span>

        <div class="filter-list">
            <div class="filter-item mb-10">
                <div class="departure-there">
                    <div class="mb-8">
                        <p class="standard-text">
                            {{localizeList.flightDepartureUpper}}:
                            <span class="blue-bold-text">{{backDepartureTime[0]|time}} – {{backDepartureTime[1]|time}}</span>
                        </p>
                    </div>

                    <div class="v-width-slider">
                        <base-slider v-model="backDepartureTime" @change="changeBackDepartureTime($event)"
                                     :size="[0,1439]"/>
                    </div>
                </div>
            </div>
        </div>

        <div class="filter-list">
            <div class="filter-item mb-6">
                <div class="departure-there">
                    <div class="mb-8">
                        <p class="standard-text">
                            {{localizeList.flightArrivalUpper}}:
                            <span class="blue-bold-text">{{backArrivalTime[0]|time}} – {{backArrivalTime[1]|time}}</span>
                        </p>
                    </div>

                    <div class="v-width-slider">
                        <base-slider v-model="backArrivalTime" @change="changeBackArrivalTime($event)"
                                     :size="[0,1439]"/>
                    </div>
                </div>
            </div>
        </div>
    </filters-block>

    <filters-block :title="localizeList.departureAirportUpper" small-header small-body>
        <div div class="input-headline-checkbox-container">
            <base-input v-model="searchDepartureTo" class="airline-search" :placeholder="localizeList.titleUpper">
                <svg width="20px" height="20px" fill="var(--lighten-7-color)">
                    <use xlink:href="../../assets/images/sprite.svg#search"></use>
                </svg>
            </base-input>
            <div v-if="departureAirportList.length" class="common-input-headline-checkbox-container">
              <span class="ellipsis common-headline-checkbox" :title="localizeList.nameForFilterHeadlineCheckbox">{{localizeList.nameForFilterHeadlineCheckbox}}</span>
              <checkbox v-model="headlineCheckbox.departureAirport"
                        @change="changeDepartureAirport('all', $event)"
                        no-gap />
            </div>
        </div>
        <div class="flight-list departure-to-list mt-8">
            <div v-for="(item, key) in departureAirportList"
                    :key="key"
                    v-show="item.isShow"
                    class="mb-6">
                <checkbox v-model="item.isChecked"
                            @change="changeDepartureAirport(key, $event)">{{item.name}}
                </checkbox>
            </div>
            <div v-show="!departureAirportList.length">
                <p class="standard-text not-result-text">{{localizeList.noResults}}</p>
            </div>
        </div>
    </filters-block>

    <filters-block :title="localizeList.transitAirportUpper" small-header small-body>
        <div div class="input-headline-checkbox-container">
            <base-input v-model="searchDirects" class="airline-search" :placeholder="localizeList.titleUpper">
                <svg width="20px" height="20px" fill="var(--lighten-7-color)">
                    <use xlink:href="../../assets/images/sprite.svg#search"></use>
                </svg>
            </base-input>
            <div v-if="directsPlaceList.length" class="common-input-headline-checkbox-container">
              <span class="ellipsis common-headline-checkbox" :title="localizeList.nameForFilterHeadlineCheckbox">{{localizeList.nameForFilterHeadlineCheckbox}}</span>
              <checkbox v-model="headlineCheckbox.directsAirport"
                        @change="changeDirectsAirport('all', $event)"
                        no-gap />
            </div>
        </div>
        <div class="flight-list direct-list mt-8">
            <div v-for="(item, key) in directsPlaceList"
                    :key="key"
                    v-show="item.isShow"
                    class="mb-6">
                <checkbox v-model="item.isChecked"
                            :disabled="transitAirportsDisabled"
                            @change="changeDirectsAirport(key, $event)">{{item.name}}
                </checkbox>
            </div>
            <div v-show="!directsPlaceList.length">
                <p class="standard-text not-result-text">{{localizeList.noResults}}</p>
            </div>
        </div>
    </filters-block>

    <filters-block :title="localizeList.arrivalAirportUpper" small-header small-body>
        <div class="input-headline-checkbox-container">
            <base-input v-model="searchDepartureBack" class="airline-search" :placeholder="localizeList.titleUpper">
                <svg width="20px" height="20px" fill="var(--lighten-7-color)">
                    <use xlink:href="../../assets/images/sprite.svg#search"></use>
                </svg>
            </base-input>
            <div v-if="arrivalAirportList.length" class="common-input-headline-checkbox-container">
              <span class="ellipsis common-headline-checkbox" :title="localizeList.nameForFilterHeadlineCheckbox">{{localizeList.nameForFilterHeadlineCheckbox}}</span>
              <checkbox v-model="headlineCheckbox.arrivalAirport"
                        @change="changeArrivalAirport('all', $event)"
                        no-gap />
            </div>
        </div>
        <div class="flight-list departure-back-list mt-8">
            <div v-for="(item, key) in arrivalAirportList"
                    :key="key"
                    v-show="item.isShow"
                    class="mb-6">
                <checkbox v-model="item.isChecked"
                            @change="changeArrivalAirport(key, $event)">{{item.name}}
                </checkbox>
            </div>
            <div v-show="!arrivalAirportList.length">
                <p class="standard-text not-result-text">{{localizeList.noResults}}</p>
            </div>
        </div>
    </filters-block>

    <filters-block :title="localizeList.airlinesUpper" small-header small-body>
        <div class="input-headline-checkbox-container">
            <base-input v-model="searchAirline" class="airline-search" :placeholder="localizeList.titleUpper">
                <svg width="20px" height="20px" fill="var(--lighten-7-color)">
                    <use xlink:href="../../assets/images/sprite.svg#search"></use>
                </svg>
            </base-input>
            <div v-if="airlineList.length" class="common-input-headline-checkbox-container">
              <span class="ellipsis common-headline-checkbox" :title="localizeList.nameForFilterHeadlineCheckbox">{{localizeList.nameForFilterHeadlineCheckbox}}</span>
              <checkbox v-model="headlineCheckbox.airline"
                        @change="changeAirlines('all', $event)"
                        no-gap />
            </div>
        </div>
        <div class="flight-list airline-list mt-8">
            <div v-for="(item, key) in airlineList"
                    :key="key"
                    v-show="item.isShow"
                    class="mb-6">
                <checkbox v-model="item.isChecked"
                            @change="changeAirlines(key, $event)">{{item.name}}
                </checkbox>
            </div>
            <div v-show="!airlineList.length">
                <p class="standard-text not-result-text">{{localizeList.noResults}}</p>
            </div>
        </div>
    </filters-block>

    <div class="v-btn-wrap">
        <base-button   @click="reset()"
                        class="mr-5"
                        background="var(--lighten-6-color)"
                        color="#727272">{{localizeList.resetFlightsUpper}}
        </base-button>
        <base-button @click="apply()">
            <span>{{localizeList.applyUpper}}</span>
        </base-button>
    </div>
   </div>
</template>

<script>
import FiltersBlock from '../tour/secondFilters/leftFilters/filtersBlock.vue'
import {bus} from "../../main"

import * as typesBasket from "@/stores/modules/basket/types"

// import basePopup from "../baseComponents/basePopup";

export default {
        name: "avia-flight-filters",
        components: {
            // "base-popup": basePopup,
            "filters-block": FiltersBlock,
        },
        data() {
            return {
                API_ORIGIN: this.$store.getters['getApiOrigin'],
                showFilters: false,
                showFilterWithSlider: false,
                buttonStatus: true,
                tariff: null,
                tariffChanged: false,
                filtersChangeStatus: false,
                transitAirportsDisabled: false,
                classItems: [
                    {
                        isChecked: false,
                        name: "economyUpper",
                        value: "economy"
                    },
                    {
                        isChecked: false,
                        name: "premiumEconomyUpper",
                        value: "premiumEconomy"
                    },
                    {
                        isChecked: false,
                        name: "businnessUpper",
                        value: "business"
                    },
                    {
                        isChecked: false,
                        name: "firstUpper",
                        value: "first"
                    }
                ],
                directsItems: [
                    {
                        name: "allUpper",
                        value: "all",
                        isChecked: false,
                    },
                    {
                        name: "withoutDirectUpper",
                        value: "withoutDirect",
                        isChecked: false,
                    },
                    {
                        name: "oneDirectUpper",
                        value: "oneDirect",
                        isChecked: false,
                    },
                    {
                        name: "twoOrMoreDirectUpper",
                        value: "twoOrMoreDirect",
                        isChecked: false,
                    }
                ],
                luggageItems: [
                    {
                        name: "allUpper",
                        value: "all",
                        isChecked: true,
                    },
                    {
                        name: "withBaggageUpper",
                        value: "withLuggage",
                        isChecked: false,
                    },
                    {
                        name: "withoutBaggageUpper",
                        value: "withoutLuggage",
                        isChecked: false,
                    }
                ],
                toDepartureTimeLimit: [0, 1439],
                toDepartureTime: [0, 1439],
                toArrivalTime: [0, 1439],
                backDepartureTime: [0, 1439],
                backArrivalTime: [0, 1439],
                toTimeLimit: [0, 0],
                backTimeLimit: [0, 0],
                toTimeLimitSize: [0, 1439],
                backTimeLimitSize: [0, 1439],
                connectionLimit: [0, 0],
                connectionLimitSize: [0, 1439],
                departureAirportList: [],
                arrivalAirportList: [],
                directsPlaceList: [],
                airlineList: [],
                searchDepartureTo: "",
                searchDepartureBack: "",
                searchDirects: "",
                searchAirline: "",
                sortValue: null,
                headlineCheckbox: {
                  airline: false,
                  arrivalAirport: false,
                  departureAirport: false,
                  directsAirport: false
                },
            }
        },
        props: {
            setFilters: {
                type: Object,
                default: () => {
                }
            },
            cityFrom: {
                type: String,
                default: ""
            },
            cityTo: {
                type: String,
                default: ""
            },
            isItemsLoaded: {
                type: Number,
                default: 0
            },
        },
        created() {
            bus.$on("avia-flight-filters-toggle", val => {
                this.showFilters = val
            });
            bus.$on("sort-avia-flight", val => {
                this.sortValue = val;
                this.flightFiltration();
            });
            bus.$on("reset-avia-fligth-filters", () => {
                this.reset()
            });
            bus.$on("changeTariffInFlightFilters", (newFilter) => {
                this.changeClassByClassName(newFilter);
            })
        },
        computed: {
            transmittedFilters(){
                // Основные фильтры, которые будут перезаполняться при смене тарифа в будущем
                let direct = this.directsItems.find(x => x.isChecked);
                direct = direct ? direct.value : "all";

                let luggage = this.luggageItems.find(x => x.isChecked);
                luggage = luggage ? luggage.value : "all";

                return { direct, luggage }
            },
            getWindowSettings(){
                return window.settings
            },
        },
        methods: {
            changeClassByClassName(newFilter)
            {
                console.log(newFilter)
                this.classItems = this.classItems.map((x) => {
                    x.isChecked = x.value === newFilter;
                    return x
                });
                const selectedTariff = this.classItems.find(x => x.isChecked).value;
                if (selectedTariff !== this.tariff) {
                    this.tariffChanged = true;
                    this.buttonStatus = false;
                }
                this.apply();
            },
            flightFiltration(classChange = false) {
                let direct = this.directsItems.find(x => x.isChecked);
                direct = direct ? direct.value : "all";

                let flightClass = this.classItems.find(x => x.isChecked);
                flightClass = flightClass ? flightClass.value : {};

                let luggage = this.luggageItems.find(x => x.isChecked);
                luggage = luggage ? luggage.value : "all";

                const checkAirlineForAllFalse = this.airlineList.every(x => !x.isChecked);
                const checkArrivalAirportForAllFalse = this.arrivalAirportList.every(x => !x.isChecked);
                const checkDepartureAirportForAllFalse = this.departureAirportList.every(x => !x.isChecked);
                const checkDirectsForAllFalse = this.directsPlaceList.every(x => !x.isChecked);

                const params = {
                    page: 1,
                    sort: this.sortValue,
                    direct: direct,
                    class: flightClass,
                    luggage: luggage,
                    connectionLimit: this.connectionLimit.slice(),
                    toTimeLimit: this.toTimeLimit.slice(),
                    backTimeLimit: this.backTimeLimit.slice(),
                    toDepartureTime: this.toDepartureTime.slice(),
                    toArrivalTime: this.toArrivalTime.slice(),
                    backDepartureTime: this.backDepartureTime.slice(),
                    backArrivalTime: this.backArrivalTime.slice(),
                    departureAirportList: checkDepartureAirportForAllFalse ? this.departureAirportList : this.departureAirportList.filter(x => x.isChecked),
                    arrivalAirportList: checkArrivalAirportForAllFalse ? this.arrivalAirportList : this.arrivalAirportList.filter(x => x.isChecked),
                    directsPlaceList: checkDirectsForAllFalse ? this.directsPlaceList : this.directsPlaceList.filter(x => x.isChecked),
                    airlineList: checkAirlineForAllFalse ? this.airlineList : this.airlineList.filter(x => x.isChecked),
                    baggageSearchOtherFares:this.$parent.baggageSearchOtherFares,
                }

                classChange = this.tariff === null ? false : this.tariff !== flightClass;
                this.tariff = flightClass;

                this.$store.dispatch("basket/" + typesBasket.A_GET_FLIGHTS_SEQUENCIES, {
                    params: params,
                    changePage: false,
                    classChange: classChange,
                    loadingText: this.localizeList.captionTextWaitingFirstPartPeriodUpper
                }).then(res => {
                    if (!classChange) {
                        this.$emit("filtred", res)
                    }
                })
                    .catch(() => {
                        alert(this.localizeList.warningTechnicalProblemsMessageUpper);
                        bus.$emit("basket-flight", false);
                        bus.$emit("page-load", false);
                    })
            },
            changeLuggage(key) {
                this.luggageItems = this.luggageItems.map((x, i) => {
                    x.isChecked = i === key;
                    return x
                });
                this.buttonStatus = false;
            },
            changeDirect(key) {
                this.directsItems = this.directsItems.map((x, i) => {
                    x.isChecked = i === key;
                    return x
                });
                this.transitAirportsEnable(this.directsItems[key].value !== "withoutDirect");
                this.buttonStatus = false;
            },
            transitAirportsEnable(value) {
                this.transitAirportsDisabled = !value;
                this.directsPlaceList.forEach(x => x.isChecked = value);
            },
            changeClass(key, firstChange = false) {
                this.classItems = this.classItems.map((x, i) => {
                    x.isChecked = i === key;
                    return x
                });
                const selectedTariff = this.classItems.find(x => x.isChecked).value;
                if (!firstChange && selectedTariff !== this.tariff) {
                    this.tariffChanged = true;
                    this.buttonStatus = false;
                }
            },
            changeToDepartureTime(e) {
                this.toDepartureTime[0] = e[0];
                this.toDepartureTime[1] = e[1];
                this.buttonStatus = false;
            },
            changeToArrivalTime(e) {
                this.toArrivalTime[0] = e[0];
                this.toArrivalTime[1] = e[1];
                this.buttonStatus = false;
            },
            changeBackDepartureTime(e) {
                this.backDepartureTime[0] = e[0];
                this.backDepartureTime[1] = e[1];
                this.buttonStatus = false;
            },
            changeBackArrivalTime(e) {
                this.backArrivalTime[0] = e[0];
                this.backArrivalTime[1] = e[1];
                this.buttonStatus = false;
            },
            changeConnectionLimit(e) {
                this.connectionLimit[0] = e[0];
                this.connectionLimit[1] = e[1];
                this.buttonStatus = false;
            },
            changeToTimeLimit(e) {
                this.toTimeLimit[0] = e[0];
                this.toTimeLimit[1] = e[1];
                this.buttonStatus = false;
            },
            changeBackTimeLimit(e) {
                this.backTimeLimit[0] = e[0];
                this.backTimeLimit[1] = e[1];
                this.buttonStatus = false;
            },
            changeDepartureAirport(key, e) {
                if (key === "all") {
                    this.departureAirportList = this.departureAirportList.map(x => {
                        x.isChecked = false;
                        return x
                    })
                } else {
                  this.departureAirportList = this.departureAirportList.map((x, i) => {
                    if (key === i) {
                        x.isChecked = e;
                    }
                    return x
                    });
                }
                this.buttonStatus = false;
            },
            changeArrivalAirport(key, e) {
                if (key === "all") {
                    this.arrivalAirportList = this.arrivalAirportList.map(x => {
                        x.isChecked = false;
                        return x
                    })
                } else {
                  this.arrivalAirportList = this.arrivalAirportList.map((x, i) => {
                    if (key === i) {
                        x.isChecked = e;
                    }
                    return x
                    });
                }
                this.buttonStatus = false;
            },
            changeDirectsAirport(key, e) {
                if (key === "all") {
                    this.directsPlaceList = this.directsPlaceList.map(x => {
                        x.isChecked = false;
                        return x
                    })
                } else {
                  this.directsPlaceList = this.directsPlaceList.map((x, i) => {
                    if (key === i) {
                        x.isChecked = e;
                    }
                    return x
                  });
                }
                this.buttonStatus = false;
            },
            changeAirlines(key, e) {
                if (key === "all") {
                    this.airlineList = this.airlineList.map(x => {
                        x.isChecked = false;
                        return x
                    })
                } else {
                  this.airlineList = this.airlineList.map((x, i) => {
                    if (i === key) {
                        x.isChecked = e;
                    }
                    return x
                  });
                }
                this.buttonStatus = false;
            },
            apply() {
                if (this.tariffChanged) {
                    this.tariffChanged = false;
                    const flightClass = this.classItems.find(x => x.isChecked);
                    bus.$emit("page-load", true);
                    this.$emit("changeTariff", flightClass.value);
                    // this.flightFiltration(true);
                } else {
                    this.flightFiltration();
                }
                this.buttonStatus = true;
                this.showFilters = false;
                this.filtersChangeStatus = false;
            },
            reset() {
                this.setDefaultFiltersParam(true, true);
            },
            closePopup() {
                this.filtersChangeStatus = false;
            },
            setDefaultFiltersParam(fromReset = false, allReset = false ) {
                // const classValue = this.setFilters.airTravelAdapterFilterValues.ClassAirTravelFilterValue;
                const classValue = this.setFilters.tariff || this.setFilters.airTravelAdapterFilterValues.ClassAirTravelFilterValue;

                let directValue;
                let luggageValue;

                if(allReset){
                    directValue = this.setFilters.airTravelAdapterFilterValues.ConnectionsFilterValue;
                    luggageValue = this.setFilters.airTravelAdapterFilterValues.LuggageFilterValue;
                } else {
                    directValue = this.transmittedFilters.direct || this.setFilters.airTravelAdapterFilterValues.ConnectionsFilterValue;
                    luggageValue = this.transmittedFilters.luggage || this.setFilters.airTravelAdapterFilterValues.LuggageFilterValue;
                }

                this.sortValue = this.setFilters.airTravelAdapterFilterValues.SortFilterValue;

                const departureTimeLimitFromAdapter = this.setFilters.airTravelAdapterFilterValues.DepartureTimeLimit
                let toDepartureTimeLimit = this.$store.getters['basket/timeToMinuts'](departureTimeLimitFromAdapter);
                toDepartureTimeLimit = isNaN(toDepartureTimeLimit) || !toDepartureTimeLimit ? 1439 : toDepartureTimeLimit;
                this.toDepartureTimeLimit = [0, toDepartureTimeLimit];
                if (this.toDepartureTime[1] > toDepartureTimeLimit) {
                    this.toDepartureTime = [this.toDepartureTime[0], toDepartureTimeLimit];
                }

                if(!departureTimeLimitFromAdapter){
                    this.toDepartureTime = [0, 1439];
                }

                this.toArrivalTime = [0, 1439];
                this.backDepartureTime = [0, 1439];
                this.backArrivalTime = [0, 1439];
                this.classItems.forEach((x, i) => {
                    if (x.value === classValue) {
                        if (fromReset) {
                            let classChenged = x.value !== this.tariff;
                            this.changeClass(i, classChenged)
                        } else {
                            this.tariff = x.value;
                            let isEconomy = x.value === this.setFilters.tariff;
                            this.changeClass(i, isEconomy)
                        }
                    }
                });
                this.directsItems.forEach((x, i) => {
                    if (x.value === directValue) {
                        this.changeDirect(i)
                    }
                });
                this.luggageItems.forEach((x, i) => {
                    if (x.value === luggageValue) {
                        this.changeLuggage(i)
                    }
                });

                const minTimeTo = this.setFilters.minFlightTimeForward;
                const maxTimeTo = this.setFilters.maxFlightTimeForward;
                const minTimeBack = this.setFilters.minFlightTimeBackward;
                const maxTimeBack = this.setFilters.maxFlightTimeBackward;
                const maxConnectionTime = this.setFilters.maxConnectionTime;
                const airTravelMaxConnectionTime = this.setFilters.airTravelAdapterFilterValues.MaxConnectionTime;
                const currentMaxConnectionTime = airTravelMaxConnectionTime === 0
                  ? maxConnectionTime : Math.min(airTravelMaxConnectionTime, maxConnectionTime)

                this.connectionLimitSize = [0, currentMaxConnectionTime];
                this.connectionLimit = [0, currentMaxConnectionTime];

                this.toTimeLimitSize = [minTimeTo, maxTimeTo];
                this.backTimeLimitSize = [minTimeBack, maxTimeBack];
                this.toTimeLimit = [minTimeTo, maxTimeTo];
                this.backTimeLimit = [minTimeBack, maxTimeBack];

                this.departureAirportList = [];
                this.arrivalAirportList = [];
                this.directsPlaceList = [];
                this.airlineList = [];              
                this.setFilters.flightsSequencies.forEach(x => {
                    let arrivalAirportKey = x.flights.filter(x2 => x2.direction === 1);
                    arrivalAirportKey = arrivalAirportKey.length - 1;
                    let helper = false;
                    let departureAirportKey = -1;
                    x.flights.forEach((x2, i2) => {
                        if (x2.direction === 2 && !helper) {
                            departureAirportKey = i2;
                            helper = true;

                        }
                    });
                    x.flights.forEach((x2, i2) => {
                        const airlineInfo = x2.segments[0].airline.mtItem
                        const airlineTo = {
                            isChecked: false,
                            isShow: true,
                            name: airlineInfo.name,
                            value: airlineInfo.code
                        }
                        if (!this.airlineList.map(x => x.value).includes(airlineInfo.code)) {
                            this.airlineList.push(airlineTo);
                        }

                        const departureInfo = x2.segments[0].departureAirport.mtItem
                        const departureTo = {
                            isChecked: false,
                            isShow: true,
                            name: `${departureInfo.code} (${departureInfo.name})`,
                            value: departureInfo.code
                        }
                        if (!this.departureAirportList.map(x => x.value).includes(departureInfo.code) && i2 === 0) {
                            this.departureAirportList.push(departureTo);
                        }

                        if (i2 === arrivalAirportKey) {

                            let arrivalInfo = x2.segments[0].arrivalAirport.mtItem;
                            const arrivalTo = {
                                isChecked: false,
                                isShow: true,
                                name: `${arrivalInfo.code} (${arrivalInfo.name})`,
                                value: arrivalInfo.code
                            }
                            if (!this.arrivalAirportList.map(x => x.value).includes(arrivalInfo.code)) {
                                this.arrivalAirportList.push(arrivalTo);
                            }
                        }
                        if (i2 !== 0 && i2 !== departureAirportKey) {
                            const departureInfo = x2.segments[0].departureAirport.mtItem
                            const departureTo = {
                              isChecked: false,
                              isShow: true,
                              name: `${departureInfo.code} (${departureInfo.name})`,
                              value: departureInfo.code
                            }
                            if (!this.directsPlaceList.map(x => x.value).includes(departureInfo.code)) {
                              this.directsPlaceList.push(departureTo);
                            }
                          }
                    })
                });
                this.departureAirportList = this.$store.getters['quicksort'](this.departureAirportList, "value");
                this.arrivalAirportList = this.$store.getters['quicksort'](this.arrivalAirportList, "value");
                this.directsPlaceList = this.$store.getters['quicksort'](this.directsPlaceList, "value");
                this.airlineList = this.$store.getters['quicksort'](this.airlineList, "name");
                this.apply()
            }
        },
        watch: {
            directsPlaceList: {
                deep: true,
                handler(value) {
                  const isSomeChecked = value.filter(x => x.isChecked).length
                  if (!isSomeChecked) {
                    this.headlineCheckbox.directsAirport = true
                  } else {
                    this.headlineCheckbox.directsAirport = false
                  }
                }
            },
            departureAirportList: {
                deep: true,
                handler(value) {
                  const isSomeChecked = value.filter(x => x.isChecked).length
                  if (!isSomeChecked) {
                    this.headlineCheckbox.departureAirport = true
                  } else {
                    this.headlineCheckbox.departureAirport = false
                  }
                }
            },
            arrivalAirportList: {
                deep: true,
                handler(value) {
                  const isSomeChecked = value.filter(x => x.isChecked).length
                  if (!isSomeChecked) {
                    this.headlineCheckbox.arrivalAirport = true
                  } else {
                    this.headlineCheckbox.arrivalAirport = false
                  }
                }
            },
            airlineList: {
              deep: true,
              handler(value) {
                const isSomeChecked = value.filter(x => x.isChecked).length
                if (!isSomeChecked) {
                  this.headlineCheckbox.airline = true
                } else {
                  this.headlineCheckbox.airline = false
                }
              }
            },
            isItemsLoaded: {
                handler(newValue, oldValue){
                    if(oldValue > 1) return;
                    this.showFilterWithSlider = true;
                },
            },
            showFilters() {
                if (!this.buttonStatus) {
                    this.$nextTick(() => {
                        this.showFilters = true;
                        this.filtersChangeStatus = true;
                    })
                }
            },
            setFilters: {
                deep: true,
                handler() {
                    this.setDefaultFiltersParam();
                }
            },
            searchDepartureTo(val) {
                if (val.length) {
                    this.departureAirportList = this.departureAirportList.map(x => {
                        if (!x.name.toLowerCase().includes(val.toLowerCase()) && !x.value.toLowerCase().includes(val.toLowerCase())) {
                            x.isShow = false
                        } else {
                            x.isShow = true
                        }

                        return x
                    })
                } else {
                    this.departureAirportList = this.departureAirportList.map(x => {
                        x.isShow = true;
                        return x
                    })
                }
            },
            searchDepartureBack(val) {
                if (val.length) {
                    this.arrivalAirportList = this.arrivalAirportList.map(x => {
                        if (!x.name.toLowerCase().includes(val.toLowerCase()) && !x.value.toLowerCase().includes(val.toLowerCase())) {
                            x.isShow = false
                        } else {
                            x.isShow = true
                        }

                        return x
                    })
                } else {
                    this.arrivalAirportList = this.arrivalAirportList.map(x => {
                        x.isShow = true;
                        return x
                    })
                }
            },
            searchDirects(val) {
                if (val.length) {
                    this.directsPlaceList = this.directsPlaceList.map(x => {
                        if (!x.name.toLowerCase().includes(val.toLowerCase()) && !x.value.toLowerCase().includes(val.toLowerCase())) {
                            x.isShow = false
                        } else {
                            x.isShow = true
                        }

                        return x
                    })
                } else {
                    this.directsPlaceList = this.directsPlaceList.map(x => {
                        x.isShow = true;
                        return x
                    })
                }
            },
            searchAirline(val) {
                if (val.length) {
                    this.airlineList = this.airlineList.map(x => {
                        if (!x.name.toLowerCase().includes(val.toLowerCase())) {
                            x.isShow = false
                        } else {
                            x.isShow = true
                        }

                        return x
                    })
                } else {
                    this.airlineList = this.airlineList.map(x => {
                        x.isShow = true;
                        return x
                    })
                }
            },
        },
        filters: {
            time(val) {
                let hour = Math.floor(val / 60)
                let minute = Math.round(val % 60)
                return (hour < 10 ? "0" + hour : hour) + ":" + (minute < 10 ? "0" + minute : minute)
            }
        }
    }
</script>

<style scoped>
 .v-sidebar-content {
    flex-grow: 1;
    /* min-width: 375px;
    max-width: 375px; */
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
 }

 .v-btn-wrap {
    padding: 20px;
    background-color: var(--white-color);
    display: flex;
    justify-content: flex-end;
 }

 .v-width-slider {
    max-width: 230px;
 }

 .v-sidebar-subtitle {
    display: inline-block;
    margin-bottom: 15px;
 }

 .input-headline-checkbox-container {
    display: flex;
    justify-content: space-between;
    gap: 12px;
    align-items: center;
    margin-bottom: 20px;
}

.common-input-headline-checkbox-container {
    display: flex;
    gap: 5px;
}

.common-headline-checkbox {
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: var(--dark-1-color);
    white-space: nowrap;
}
</style>
